import { Button } from "primereact/button";
import { FileUpload } from "primereact/fileupload";
import { InputText } from "primereact/inputtext";
import React, { useEffect, useState } from "react";
import "./UploadPic.css";
export default function UploadPic({ setDialog, dataFile, setDataFile, onSaveFile, typeFile }) {
    const [tmpFile, setTmpFile] = useState({ selectImg: undefined });

    useEffect(() => {
        //console.log('dataFile ',dataFile);
    }, [dataFile]);

    const uploadFile = async (invoiceFile, fileName, file, checkSave) => {
        // if (checkSave === "SAVE") {
        //     // await this.MasterService.master_gen_doc(this, 'path_file_gen', "uploadfile", {
        //     //     base64String: invoiceFile,
        //     //     // fileName: fileName,
        //     //     path_file: '.' + fileName,
        //     //     action_check: 'SAVE'
        //     // })
        //     //     .then(function (response) {
        //     //         console.log(response);
        //     //     })
        //     //     .catch(function (error) {
        //     //         console.log(error);
        //     //     });
        //     // fileUpload, setFileUpload
        // } else
        if (checkSave === "CLEAR") {
            setDataFile({ fileUpload: null });
            setTmpFile({});
        } else {
            let typefile = fileName.substr(fileName.lastIndexOf(".") + 1).split(".")[0];
            let data_file = {
                base64String: invoiceFile,
                fileName: fileName,
                file: file,
                typefile: fileName === typeFile ? "" : typefile,
            };
            setDataFile({ fileUpload: data_file });
        }
    };

    const fileUploadHandler = ({ files }) => {
        const [file] = files;
        const fileReader = new FileReader();

        fileReader.onload = (e) => {
            uploadFile(e.currentTarget.result, file.name, file);
        };
        // setfileParth(file.objectURL);
        fileReader.readAsDataURL(file);

        setTmpFile({
            ...tmpFile,
            selectImg: file,
        });
    };

    const onClearFile = async () => {
        try {
            uploadFile(null, null, null, "CLEAR");

            setTmpFile({
                ...tmpFile,
                selectImg: undefined,
            });

            setDialog({ dialog: true, show: false, act: "reload" });
        } catch (error) {}
    };

    const onClose = () => {
        try {
            uploadFile(null, null, null, "CLEAR");

            setTmpFile({
                ...tmpFile,
                selectImg: undefined,
            });
        } catch (error) {}
        setDialog({ dialog: false, show: true });
    };

    return (
        <div className="p-grid p-fluid media-demo">
            <div className="p-col-12">
                <div className="card">
                    <div className="p-grid  p-fluid">
                        <div className="p-col-12 p-md-12 " style={{ textAlign: "center" }}>
                            {/* <h5><u><b>เพิ่มรูปถ่าย</b></u></h5>     */}
                        </div>

                        <div className="p-col-12 p-md-4 upload-responsive " style={{ textAlign: "right", marginTop: "3px" }}>
                            <FileUpload
                                id="picup"
                                mode="basic"
                                name={tmpFile.selectImg}
                                accept={typeFile ? typeFile : "image/*"}
                                // maxFileSize={1000000}
                                chooseLabel={"เลือกไฟล์"}
                                className="span-upload-responsive"
                                disabled={tmpFile.selectImg && tmpFile.selectImg != null ? true : false}
                                customUpload={true}
                                uploadHandler={fileUploadHandler}
                                auto
                            />
                        </div>
                        <div className="p-col-12 p-md-6 upload-responsive " style={{ textAlign: "left" }}>
                            <div className="p-inputgroup" style={{ marginLeft: 5, marginTop: 10 }}>
                                <span
                                    className="p-inputgroup-addon "
                                    style={{
                                        width: 80,
                                        color: "#ffffff",
                                        background: "#2196F3",
                                        border: "1px solid #2196F3",
                                        opacity: 0.6,
                                    }}
                                >
                                    ชื่อไฟล์
                                </span>
                                <span className="p-float-label">
                                    <InputText type="text" id="inputgroup" placeholder="เลือกไฟล์ เพื่ออัพโหลด" disabled value={tmpFile.selectImg && tmpFile.selectImg != null ? tmpFile.selectImg.name : ""} />
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="p-grid" style={{ textAlign: "center" }}>
                        <div className="p-col-12">
                            <Button className="p-button p-button-success  p-mr-2 p-mb-2" icon="pi pi-upload" label="อัปโหลด" disabled={tmpFile.selectImg && tmpFile.selectImg != null ? false : true} style={{ width: 150 }} onClick={() => onSaveFile()} />

                            <Button className="p-button-secondary p-button p-mr-2 p-mb-2" icon="pi pi-arrow-left" label="กลับหน้าจอหลัก" style={{ width: 150 }} onClick={() => onClose()} />

                            {tmpFile.selectImg && tmpFile.selectImg != null ? <Button type="button" icon="pi pi-trash" label="ยกเลิก" className="p-button p-button-danger p-button p-mr-2 p-mb-2" style={{ width: 150, marginLeft: "5px" }} onClick={() => onClearFile()} /> : ""}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
